import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedBackToAirButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedBackToAirButton = useCallback(() => {
    track(`Clicked 'Back to Air' button`);
  }, [track]);

  return { trackClickedBackToAirButton };
};
